import { ClosingPageWrapper } from "features/closings/ClosingPageWrapper";
import { getClosingRetrieveLoader } from "gen/endpoints/closing/closing";
import { getCommitmentInformationTableDataRetrieveLoader } from "gen/endpoints/commitment-information-table-data/commitment-information-table-data";
import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";
import { composeLoaders } from "shared/utils/RoutingUtils";

const createEqualizationAndTrueUpRoutes = (
  equalizationFirst: boolean,
): RouteObject[] => {
  const idPrefix = equalizationFirst
    ? "equalizationFirst"
    : "equalizationSecond";
  const equalizationRoute = {
    id: `${idPrefix}ClosingEqualization`,
    path: equalizationFirst
      ? "equalizationBeforeTrueUp"
      : "equalizationAfterTrueUp",
    lazy: async () => {
      const { ClosingTabEqualizations } = await import(
        "features/closings/tabs/ClosingTabEqualizations"
      );
      return { Component: ClosingTabEqualizations };
    },
    handle: {
      title: i18n.t("closing:equalizationPreview"),
    },
  };
  const feeTrueUpsRoute = {
    id: `${idPrefix}ClosingFeeTrueUp`,
    path: equalizationFirst
      ? "feeTrueUpAfterEqualization"
      : "feeTrueUpBeforeEqualization",
    lazy: async () => {
      const { ClosingTabFeeTrueUps } = await import(
        "features/closings/tabs/ClosingTabFeeTrueUps"
      );
      return { Component: ClosingTabFeeTrueUps };
    },
    handle: {
      title: i18n.t("closing:feeCatchUp"),
    },
  };
  return equalizationFirst
    ? [equalizationRoute, feeTrueUpsRoute]
    : [feeTrueUpsRoute, equalizationRoute];
};

export const closingRoutes: RouteObject = {
  id: "closing",
  path: "closing",
  element: <ClosingPageWrapper />,
  children: [
    {
      id: "closingEdit",
      path: ":closingId/edit/*",
      lazy: async () => {
        const { ClosingEditPage } = await import(
          "features/closings/ClosingEditPage"
        );
        return { Component: ClosingEditPage };
      },
      loader: composeLoaders(getClosingRetrieveLoader()),
      children: [
        {
          id: "closingCommitments",
          path: "",
          lazy: async () => {
            const { ClosingTabCommitments } = await import(
              "features/closings/tabs/ClosingTabCommitments"
            );
            return { Component: ClosingTabCommitments };
          },
          loader: composeLoaders(
            getClosingRetrieveLoader(),
            getCommitmentInformationTableDataRetrieveLoader(),
            getCommitmentInformationTableDataRetrieveLoader(),
          ),
          handle: {
            title: i18n.t("common:commitments"),
          },
        },
        ...createEqualizationAndTrueUpRoutes(true),
        ...createEqualizationAndTrueUpRoutes(false),
      ],
    },
  ],
};
